import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    Box,
    List,
    ListItem,
    ListItemText,
    Alert,
    Divider
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import WarningIcon from '@mui/icons-material/Warning';
import ErrorIcon from '@mui/icons-material/Error';

const ImportResultDialog = ({ open, onClose, result }) => {
    if (!result) return null;

    const { importedCount = 0, skippedCount = 0, errors = [] } = result;
    const total = importedCount + skippedCount + errors.length;
    const hasErrors = errors.length > 0;

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle>
                Import Results
            </DialogTitle>
            <DialogContent>
                <Box sx={{ mb: 2 }}>
                    <Alert severity={hasErrors ? 'warning' : 'success'} sx={{ mb: 2 }}>
                        <Typography variant="body1">
                            Imported {importedCount} of {total} frame{total > 1 ? 's' : ''}
                        </Typography>
                    </Alert>
                </Box>

                {importedCount > 0 && (
                    <Box sx={{ mb: 2 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                            <CheckCircleIcon color="success" sx={{ mr: 1 }} />
                            <Typography variant="h6">
                                Imported ({importedCount})
                            </Typography>
                        </Box>
                        <Typography variant="body2" color="text.secondary">
                            {importedCount} frame{importedCount > 1 ? 's' : ''} successfully added to your catalog
                        </Typography>
                    </Box>
                )}

                {skippedCount > 0 && (
                    <Box sx={{ mb: 2 }}>
                        <Divider sx={{ my: 2 }} />
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                            <WarningIcon color="warning" sx={{ mr: 1 }} />
                            <Typography variant="h6">
                                Skipped ({skippedCount})
                            </Typography>
                        </Box>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                            Frame{skippedCount > 1 ? 's' : ''} already exist in your catalog
                        </Typography>
                    </Box>
                )}

                {errors.length > 0 && (
                    <Box>
                        <Divider sx={{ my: 2 }} />
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                            <ErrorIcon color="error" sx={{ mr: 1 }} />
                            <Typography variant="h6">
                                Failed ({errors.length})
                            </Typography>
                        </Box>
                        <List dense sx={{ maxHeight: 300, overflow: 'auto' }}>
                            {errors.map((error, idx) => (
                                <ListItem key={idx} sx={{ pl: 0, py: 0.5 }}>
                                    <ListItemText
                                        primary={`Row ${idx + 1}`}
                                        secondary={error}
                                        primaryTypographyProps={{ variant: 'body2', fontWeight: 500 }}
                                        secondaryTypographyProps={{ variant: 'caption', color: 'error' }}
                                    />
                                </ListItem>
                            ))}
                        </List>
                    </Box>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} variant="contained">
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ImportResultDialog;
